export default "__VITE_ASSET__LrWCmpwN__"